import { render, staticRenderFns } from "./StoreBox.vue?vue&type=template&id=7f7dd4df&scoped=true"
import script from "./StoreBox.vue?vue&type=script&lang=js"
export * from "./StoreBox.vue?vue&type=script&lang=js"
import style0 from "./StoreBox.vue?vue&type=style&index=0&id=7f7dd4df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7dd4df",
  null
  
)

export default component.exports